import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MenuItem, TextField } from '@mui/material';
import buttonStyles from '../../../styles/buttons.module.css';
import { Spinner } from '@developers/ui';

function OrderManagementRequestForm(props) {
  
  const [form, setForm] = React.useState({ action: '', reason: '', extra_info: '' });
  const [errors, setErrors] = React.useState({ action: '', reason: '', extra_info: '' });

  function handleFormChange(e, field) {
    props.setFormSubmitted(false);
    setErrors({ action: '', reason: '', extra_info: '' });

    if (field == 'action') {
      setForm({ ...form, reason: '', [field]: e.target.value });
    } else {
      setForm({ ...form, [field]: e.target.value });
    }
  }

  function handleDialogSubmit() {
    const new_errors = validate();
    setErrors(new_errors);
    
    if (new_errors.action == '' && new_errors.reason == '' && new_errors.extra_info == '') {
      props.submitForm(form)
      resetForm();
    }
  }

  function validate() {
    let newErrors = { action: '', reason: '', extra_info: '' };

    if (form.action == '') {
      newErrors.action = 'You must choose whether you want to edit your order or cancel it';
    }

    if (form.reason == '' && form.action !== '') {
      newErrors.reason = 'You must provide a reason';
    }

    if (form.action == 'cancel' && form.reason !== '' && form.extra_info == '') {
      newErrors.extra_info = 'You must provide additional details as to why you want to cancel your order';
    }

    return newErrors;
  }

  function resetForm() {
    setErrors({ action: '', reason: '', extra_info: '' })
    props.setFormSubmitted(true);
    setForm({ action: '', reason: '', extra_info: '' });
  }

  return (
    <Dialog 
        open={props.openOrderManagement} 
        onClose={() => props.setOpenOrderManagement(false)}
        fullWidth
        maxWidth='sm'
      >
        <Spinner show={props.modifyOrderMeta.loading} />
        <DialogTitle>Manage Order</DialogTitle>
        <DialogContent>
          {(props.modifyOrderMeta.success && props.formSubmitted) ?
            <DialogContentText>
              Your order has been placed in the approval pending status, we will reply shortly in regards to this matter. Thanks and have a great day.
            </DialogContentText>
          :
            <>
              <DialogContentText>
                  Please fill out the form below. This information will be sent to our Support Team so that they can handle your request.
              </DialogContentText>
              <TextField
                select
                fullWidth
                margin='dense'
                label='What are you wanting to do with your order?'
                error={errors.action !== ''}
                value={form.action}
                onChange={(e) => handleFormChange(e, 'action')}
              >
                <MenuItem value=''>Choose an action</MenuItem>
                <MenuItem value='edit'>Edit</MenuItem>
                <MenuItem value='cancel'>Cancel</MenuItem>
              </TextField>
              {form.action == 'edit' && 
                <TextField
                  multiline
                  fullWidth
                  rows={5}
                  margin='dense'
                  label='What do you need to change on your order?'
                  error={errors.reason !== ''}
                  value={form.reason}
                  onChange={(e) => handleFormChange(e, 'reason')}
                />
              }
              {form.action == 'cancel' &&
                <TextField
                  select
                  fullWidth
                  margin='dense'
                  label='Why do you need to cancel?'
                  error={errors.reason !== ''}
                  value={form.reason}
                  onChange={(e) => handleFormChange(e, 'reason')}
                >
                  <MenuItem value=''>Choose a reason</MenuItem>
                  <MenuItem value='i ordered the wrong parts'>I ordered the wrong parts</MenuItem>
                  <MenuItem value='i need to modify this order'>I need to modify this order</MenuItem>
                  <MenuItem value='item out of stock/too long of wait'>Item out of stock/Too long of wait</MenuItem>
                  <MenuItem value='need to change shipping address'>Need to change shipping address</MenuItem>
                  <MenuItem value='need to change shipping speed'>Need to change shipping speed</MenuItem>
                  <MenuItem value='need to change billing address'>Need to change billing address</MenuItem>
                  <MenuItem value='need to change payment method'>Need to change payment method</MenuItem>
                  <MenuItem value='ordered from elsewhere'>Ordered from elsewhere</MenuItem>
                  <MenuItem value='other'>Other</MenuItem>
                </TextField>
              }
              {(form.action == 'cancel' && form.reason !== '') &&
                <TextField
                  multiline
                  fullWidth
                  rows={5}
                  margin='dense'
                  helperText='*Include any details that our Support Team will need to know to correctly update/cancel your order (New address, different shipping speed, etc.)'
                  label='Additional Information'
                  error={errors.extra_info !== ''}
                  value={form.extra_info}
                  onChange={(e) => handleFormChange(e, 'extra_info')}
                />
              }
              <DialogContentText sx={{ color: 'red' }}>
                {errors.action}<br />{errors.reason}<br />{errors.extra_info}
              </DialogContentText>
            </>
          }
          {(props.formSubmitted && errors.action == '' && errors.reason == '' && errors.extra_info == '') ?
            <DialogActions>
              <button className={buttonStyles.cancelButton} onClick={() => props.setOpenOrderManagement(false)}>Close</button>
            </DialogActions>
          :
            <DialogActions>
              <button className={buttonStyles.cancelButton} onClick={() => props.setOpenOrderManagement(false)}>Cancel</button>
              <button className={buttonStyles.submitButton} onClick={handleDialogSubmit}>Submit</button>
            </DialogActions>
          }
        </DialogContent>
      </Dialog>
  );
}

export default OrderManagementRequestForm;